import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tellimuse kommentaar

  <span style="color:#85c1dc;">**FI:**</span>
  Tilauksen lisätieto

  <span style="color:#85c1dc;">**RU:**</span>
  Комментарий к заказу
*/
/* @__NO_SIDE_EFFECTS__ */
const m1911 = msg(
  mf`Tellimuse kommentaar`,
  mf`Tilauksen lisätieto`,
  mf`Комментарий к заказу`,
)

export { m1911 as 'w.basket.order_note' }